// extracted by mini-css-extract-plugin
export var btnWrapper = "info-module--btn-wrapper--yJ3if";